import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { TextAssetCollectionWithRecommendations } from './components';
import { shortHeadlineType } from '../../util';

export const SceneWrapperTextAssetCollectionWithRecommendations = ({
  scene,
  shouldDisplay,
  url,
  disableCopilot,
  i18n,
  serverContext,
  campaignId,
  onTextListUpdate,
}) => {
  const getTextAssets = (text, textData, index) => {
    let maxLength = 30;
    let hint = shortHeadlineType.TextOverlay;
    if (textData && textData.length > index) {
      maxLength = textData[index].maxLength || 30;
      hint = textData[index].hint || shortHeadlineType.TextOverlay;
    }
    return {
      minLength: 0,
      maxLength,
      isMultipleOptions: false,
      display: true,
      text: text ? text.slice(0, maxLength) : '',
      placeholder: '',
      hint,
    };
  };
  const metaData = useMemo(() => {
    if (scene && scene.updating) {
      return scene.updating;
    }
    return null;
  }, [scene]);
  const shortHeadline = useCallback((text, textData, index) => getTextAssets(text, textData, index), []);
  const textList = useMemo(() => (metaData && metaData.text) || [], [metaData]);
  const textDataList = useMemo(() => (metaData && metaData.textData) || [], [metaData]);

  return (
    <>
      {
        shouldDisplay && textList.length > 0 && textList.map((text, index) => (
          <div
            className={mergeClasses('adjust-text-collection')}
          >
            <TextAssetCollectionWithRecommendations
              url={url}
              disableCopilot={disableCopilot}
              i18n={i18n}
              campaignId={campaignId}
              serverContext={serverContext}
              onChangeTexts={newText => onTextListUpdate(newText, textDataList, index)}
              shortHeadline={shortHeadline(text, textDataList, index).text}
              shortHeadlineValidations={shortHeadline(text, textDataList, index)}
              longHeadlineValidations={{ display: false }}
              descriptionValidations={{ display: false }}
              hideTextFormatting
            />
          </div>
        ))
      }
    </>
  );
};

SceneWrapperTextAssetCollectionWithRecommendations.propTypes = {
  scene: PropTypes.shape({
    id: PropTypes.string.isRequired,
    updating: PropTypes.shape({
      textData: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        maxLength: PropTypes.number,
      })),
    }),
  }).isRequired,
  shouldDisplay: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  disableCopilot: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({ getString: PropTypes.func, getLocale: PropTypes.func }).isRequired,
  serverContext: PropTypes.shape({
    CurrentLocale: PropTypes.string.isRequired,
  }).isRequired,
  campaignId: PropTypes.string.isRequired,
  onTextListUpdate: PropTypes.func.isRequired,
  recommendedAssetsResponse: PropTypes.shape({
    RecommendedAssets: PropTypes.shape({}),
    Logo: PropTypes.string,
  }).isRequired,
};
